<template>
  <div
    v-if="open"
    ref="dialog"
    class="modal fade show d-block"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    aria-labelledby="logoutModalTitle"
    @click.self="closeModal"
    @keydown.esc="closeModal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 id="logoutModalTitle" class="modal-title fs-5">Deslogar</h1>
          <button
            type="button"
            class="btn-close"
            aria-label="Fechar"
            :disabled="loggingOut"
            @click="closeModal"
          ></button>
        </div>

        <div class="modal-body">
          Tem certeza de que deseja deslogar? Para acessar novamente, você precisará informar seu e-mail e sua senha.
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" :disabled="loggingOut" @click="closeModal">
            Cancelar
          </button>
          <button type="button" class="btn btn-primary" :disabled="loggingOut" @click="logoutUser">
            <span v-if="loggingOut" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
            {{ loggingOut ? "Deslogando..." : "Deslogar" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="open" class="modal-backdrop fade show"></div>
</template>

<script>
import { nextTick } from "vue";
import { mapActions } from "vuex";

export default {
  name: "LogoutModal",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close"],
  data() {
    return {
      loggingOut: false,
    };
  },
  watch: {
    open(isOpen) {
      document.body.classList.toggle("modal-open", isOpen);

      if (isOpen) {
        nextTick(() => this.$refs.dialog?.focus());
      }
    },
  },
  beforeUnmount() {
    document.body.classList.remove("modal-open");
  },
  methods: {
    ...mapActions(["logoffSession"]),
    closeModal() {
      if (!this.loggingOut) {
        this.$emit("close");
      }
    },
    async logoutUser() {
      if (this.loggingOut) {
        return;
      }

      this.loggingOut = true;
      await this.logoffSession();
    },
  },
};
</script>
